import { sizes } from '@lmc/common/constants'
import { TableOLD } from '@lmc/ui-kit'
import type dayjs from 'dayjs'
import type * as React from 'react'
import './CareDeliveryTable.less'
import { SAFEGUARDING_ITEM_ID } from '@lmc/common/types'
import type { LogCategory, LogCategoryItem } from '@lmc/ts-common'
import { Skeleton } from 'antd'
import useSafeguardingAccess from 'components/AccessControl/useSafeguardingAccess'
import type { Data } from '../../CareDeliveryScreen.types'
import { formatTableData, getTableColumns } from './CareDeliveryTable.utils'

export type CareDeliveryTableProps = {
  items: LogCategoryItem[]
  categories: LogCategory[]
  to: dayjs.Dayjs
  from: dayjs.Dayjs
  data: Data[]
  categoryId: string
  isLoading: boolean
  preferredPeopleNominative: string
}

export const CareDeliveryTable = ({
  data,
  items,
  to,
  from,
  categories,
  categoryId,
  isLoading,
  preferredPeopleNominative
}: CareDeliveryTableProps): React.ReactElement => {
  if (!data || !items || !categories) {
    return (
      <div className="care-delivery-skeleton">
        <Skeleton active />
      </div>
    )
  }

  const safeguardingAccess = useSafeguardingAccess()

  const filteredItems = safeguardingAccess
    ? items
    : items.filter((item) => item.id !== SAFEGUARDING_ITEM_ID)

  const columns = getTableColumns({
    items: filteredItems,
    to,
    from,
    categories,
    categoryId,
    preferredPeopleNominative
  })

  const tableData = formatTableData(data)

  return (
    <TableOLD
      containerClass="table-striped"
      size="middle"
      loading={isLoading}
      scroll={{ x: sizes.childScreen }}
      pagination={{
        pageSize: 10,
        position: ['bottomRight']
      }}
      columns={columns}
      rows={tableData}
    />
  )
}

export default CareDeliveryTable
